// only accepts hexadecimal backgrounds

export function lightOrDarkColor(bgColor: string) {
	let color = bgColor[0] === "#" ? bgColor.slice(1) : bgColor;

	if (color.length === 3) {
		color = color.replaceAll(/(.{1})/g, "$1$1");
	}

	const red = parseInt(color.slice(0, 2), 16);
	const green = parseInt(color.slice(2, 4), 16);
	const blue = parseInt(color.slice(4, 6), 16);

	if (red * 0.299 + green * 0.587 + blue * 0.114 > 134) {
		return "#000"; // bright colors - return black font
	}

	return "#FFF"; // dark colors - return white font
}
